// PageTitleWatcher.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { WEBSITE_NAME } from "../../modals/Constants";

export default function PageTitleWatcher() {
  const location = useLocation();

  useEffect(() => {
    switch (location.pathname) {
      case "/home":
        document.title = "Home";
        break;
      case "/signin":
        document.title = WEBSITE_NAME + " | Signin";
        break;
      case "/account":
        document.title = "My Account";
        break;
      case "/myaddress":
        document.title = "My Addresses";
        break;
      case "/mybag":
        document.title = "My Bag";
        break;
      case "/myorders":
        document.title = "My Orders";
        break;
      case "/myorder-details":
        document.title = "Order Details";
        break;
      case "/pages/terms-and-condition":
        document.title = "Terms & Condition";
        break;
      case "/pages/privacy-policy":
        document.title = "Privacy Policy";
        break;
      case "/pages/return-policy":
        document.title = "Return Policy";
        break;
      case "/pages/about-us":
        document.title = "About us";
        break;
      case "/pages/contact-us":
        document.title = "Contact us";
        break;
      default:
        document.title = WEBSITE_NAME;
    }
  }, [location]);

  return null;
}